var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackLid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 149,
    viewBox: "0 0 210 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.499 0.903133C104.427 0.367234 105.571 0.367236 106.499 0.903135L208.256 59.6525C209.184 60.1884 209.756 61.1788 209.756 62.2506V86.7494C209.756 87.8212 209.184 88.8116 208.256 89.3475L104.999 148.963L1.74218 89.3475C0.81398 88.8116 0.242188 87.8212 0.242188 86.7494V62.2506C0.242188 61.1788 0.813984 60.1884 1.74219 59.6525L103.499 0.903133Z",
    fill: "#212B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.826 0.0371094L208.639 60.5054L104.826 120.974L1.01367 60.5054L104.826 0.0371094Z",
    fill: "url(#paint0_linear_1506_141)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1506_141",
    x1: 104.826,
    y1: 0.0371094,
    x2: 104.826,
    y2: 120.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLid);
export default __webpack_public_path__ + "static/media/black-lid.b5af3b293d17261d8e070c29de572528.svg";
export { ForwardRef as ReactComponent };